export default "__VITE_ASSET__Csx6Z5fR__"